import Header from '../../components/feature/Header';

export default function About() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">關於我們</h1>
            <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
          </div>
          
          <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <img 
                  src="https://static.readdy.ai/image/e7430320e3bc3f9244a461515e2266b3/1ae4e0dfdcdaa258075bd2a15f36098e.jpeg"
                  alt="和明營造有限公司"
                  className="w-full h-64 object-cover rounded-lg"
                />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">和明營造有限公司</h2>
                <p className="text-gray-600 leading-relaxed">
                  和明營造有限公司成立於民國90年，主要承攬國內各類公共工程及民間建築工程。公司承作範圍涵蓋土木、建築、區域排水、環境改善、室內裝修、災害修復、農路改善及道路維修等項目。歷年各項工程履約績效良好，深獲業主及主辦機關肯定，並與協力廠商保持長期穩定的合作關係，致力於提供安全、專業與高品質的施工服務。
                </p>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                <i className="ri-building-line text-blue-600 mr-2"></i>
                公司資訊
              </h3>
              <div className="space-y-3">
                <div className="flex items-start">
                  <i className="ri-map-pin-line text-blue-600 mr-2 mt-1"></i>
                  <div>
                    <strong>地址：</strong>
                    <span className="text-gray-600">屏東縣高樹鄉田子村平安巷1-2號1樓</span>
                  </div>
                </div>
                <div className="flex items-center">
                  <i className="ri-phone-line text-blue-600 mr-2"></i>
                  <div>
                    <strong>電話：</strong>
                    <span className="text-gray-600">0989964485</span>
                  </div>
                </div>
                <div className="flex items-center">
                  <i className="ri-mail-line text-blue-600 mr-2"></i>
                  <div>
                    <strong>信箱：</strong>
                    <span className="text-gray-600">nero.nero@msa.hinet.net</span>
                  </div>
                </div>
                <div className="flex items-center">
                  <i className="ri-user-line text-blue-600 mr-2"></i>
                  <div>
                    <strong>負責人：</strong>
                    <span className="text-gray-600">葉芷玲</span>
                  </div>
                </div>
                <div className="flex items-center">
                  <i className="ri-file-text-line text-blue-600 mr-2"></i>
                  <div>
                    <strong>統一編號：</strong>
                    <span className="text-gray-600">13144873</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                <i className="ri-tools-line text-blue-600 mr-2"></i>
                服務範圍
              </h3>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-600">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  土木工程
                </li>
                <li className="flex items-center text-gray-600">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  建築工程
                </li>
                <li className="flex items-center text-gray-600">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  區域排水
                </li>
                <li className="flex items-center text-gray-600">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  環境改善
                </li>
                <li className="flex items-center text-gray-600">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  室內裝修
                </li>
                <li className="flex items-center text-gray-600">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  災害修復
                </li>
                <li className="flex items-center text-gray-600">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  農路改善
                </li>
                <li className="flex items-center text-gray-600">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  道路維修
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
